import axios from 'axios'
import {BASE_URL} from '../config'
import {IOverviewCount} from './_model'
import {useQuery} from 'react-query'
import {OverviewCard} from '../../utils/components/OverviewCard'

const GET_OVERVIEW_COUNT_URL = `${BASE_URL}/api/protect/allTypeTicketCountByUser`

const TicketOverview = () => {
  const {data, isLoading} = useQuery({
    queryKey: ['overviewCount'],
    queryFn: async () => {
      const response = await axios.get<IOverviewCount>(GET_OVERVIEW_COUNT_URL)

      return response.data
    },
  })

  return (
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      {/* begin::Col */}
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <OverviewCard
          className='h-md-50 mb-5 mb-xl-10'
          title='Reply'
          subtitle='Tickets'
          color='#F1416C'
          count={data?.Reply}
          isLoading={isLoading}
        />
        <OverviewCard
          className='h-md-50 mb-5 mb-xl-10'
          title='Awaiting'
          subtitle='Tickets'
          color='#7239EA'
          count={data?.awatting}
          isLoading={isLoading}
        />
      </div>
      {/* begin::Col */}
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <OverviewCard
          className='h-md-50 mb-5 mb-xl-10'
          title='Open'
          subtitle='Tickets'
          color='#7239EA'
          count={data?.open}
          isLoading={isLoading}
        />
        <OverviewCard
          className='h-md-50 mb-5 mb-xl-10'
          title='Total'
          subtitle='Tickets'
          color='#F1416C'
          count={data?.total}
          isLoading={isLoading}
        />
      </div>
      {/* end::Col */}

      {/* begin::Col */}
      <div className='col-xxl-6 align-self-center'>{/* <BrandedNonBrandedChart /> */}</div>
      {/* end::Col */}
    </div>
  )
}

export default TicketOverview
